import { Sk } from './shared';

export function MkWizard() {
  return (
    <div className="csmk csmk-wizard">
      <div className="steps">
        <div className="step active">
          <div className="node">1</div>
          <div className="cap">Describe</div>
        </div>
        <div className="bar" />
        <div className="step">
          <div className="node">2</div>
          <div className="cap">Details</div>
        </div>
        <div className="bar" />
        <div className="step">
          <div className="node">3</div>
          <div className="cap">Solution</div>
        </div>
      </div>
      <div className="ta">
        <span className="lbl">Project scenario</span>
        <Sk w="92%" h="5px" /><Sk w="58%" h="5px" />
      </div>
      <div className="wbtn">Continue to Step 2 →</div>
    </div>
  );
}
